import React from 'react';
import { loadScoresFromLocal, saveScoresToLocal } from '../scores';
import { getCollectionStorage } from '../helpers';
import "../styles.css";

export default function SaveLoad() {
  const saveToFile = () => {
    const data = {
      scores: loadScoresFromLocal(),
      cardCollection: getCollectionStorage(),
      taskCount: localStorage.getItem("taskCount"),
      lastTaskTimestamp: localStorage.getItem("lastTaskTimestamp")
    };
    const json = JSON.stringify(data);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'game_data.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const contents = e.target.result;
      const data = JSON.parse(contents);
      saveScoresToLocal(data.scores);
      localStorage.setItem("cardCollection", JSON.stringify(data.cardCollection));
      localStorage.setItem("taskCount", data.taskCount);
      localStorage.setItem("lastTaskTimestamp", data.lastTaskTimestamp);
      // Optionally, update your state to reflect the changes
    };
    reader.readAsText(file);
  };

  return (
    <div className="save-load-container">
      {/* Save button */}
      <button className="save-button" onClick={saveToFile}>Save Game</button>
      {/* Load button */}
      <label htmlFor="file" className="file-label">Load Game</label>
      <input id="file" type="file" className="file-input" onChange={handleFileUpload} />
    </div>
  );
}
